import React, { useContext, useEffect, useState } from "react";
import Surface from "../components/Surface";
import translate from "../i18n/Translator";
import { RouterParams } from "../router/RouterParams";
import { useHistory } from "react-router-dom";
import CodeIcon from '@material-ui/icons/Code';
import FileCopyIcon from '@material-ui/icons/FileCopyOutlined';
import { AppContext } from "../context/AppContext";
import { ApiLog } from "../api/ApiLog";
import { getApiLog as getTenantApiLog} from "../api/ApiLogApi";
import { getApiLog } from "../api/SupportAPI";
import { Box, Button, Card, Grid, Typography } from "@material-ui/core";
import DateFormat from "../components/DateFormat";
import CodeInput from "../components/CodeInput";
import { ErrorSnackbar, SuccessSnackbar } from "../components/Snackbars";
import Progress from "../components/Progress";



export default function ApiLogDetail({ match }: RouterParams) {
    const context = useContext(AppContext);
    const [status, setStatus] = useState<string>("loading");
    const history = useHistory();
    const [apiLog, setApiLog] = useState<ApiLog>();
    const [error, setError] = useState<string>();
    const isTenant = context.session!.role.id === "owner";
    const [success, setSuccess] = useState<string | JSX.Element | JSX.Element[]>();
    const load = () => {
        setStatus("loading");
        if(isTenant){
            getTenantApiLog(context.session!.tenant!.id, match.params.apiLogId).then((response) => {
                setApiLog(response);
            } ).catch((error) => {
                setError(error.message);
            }).finally(() => {
                setStatus("loaded");
            });
        } else {
            getApiLog(match.params.apiLogId).then((response) => {
                setApiLog(response);
            } ).catch((error) => {
                setError(error.message);
            }).finally(() => {
                setStatus("loaded");
            });
        }
    }

    const copyToClipoard = (content : string | undefined) => {
        if(content) {
            navigator.clipboard.writeText(content);
            setSuccess(translate("api_logs.detail.copy_message") as string);
        }
    };

    useEffect(load, [context.session]);

    const onCloseSnackbars = () => {
        setError(undefined);
        setSuccess(undefined);
    }

    if (status === "loading") {
        return <Progress />;
    }

    const buildField = (key : string, value : any) => {
        return (
            <Box px={2}>
                <Grid container justify="center" alignContent="center" alignItems="center" spacing={2} id={key}>
                    <Grid item xs={4}>
                        {translate(`api_logs.detail.${key}`) as string}
                    </Grid>
                    <Grid item xs={8}>
                        {value}
                    </Grid>
                </Grid>
            </Box>
        );
    }

    return(
        <div>
            <Surface title={translate("api_logs.detail.title", {"id" : apiLog?.id}) as string} subtitle={`${apiLog?.method} ${apiLog?.url}`}
                className="PaperPagination PaperTabContainer" backButton onAction={history.goBack} icon={<CodeIcon />}>
                <Box py={2} px={2}>
                    <Grid container alignItems="flex-start" justify="space-between" spacing={3}>
                            <Grid item xs={12}>
                            <Card variant="outlined">
                                <Grid container>
                                    <Grid item xs={12} md={6}>
                                        {buildField("date", <DateFormat date={apiLog?.date} format="DD/MM/YYYY hh:mm:ss" />)}
                                        {buildField("id", apiLog?.id)}
                                        {buildField("public_key", apiLog?.public_key)}
                                        {buildField("ip_address", apiLog?.ip)}
                                        {buildField("response_code", apiLog?.response_code)}
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        {buildField("tenant", apiLog?.tenant_name)}
                                        {buildField("private_key", apiLog?.private_key)}
                                        {buildField("agent", apiLog?.user_agent)}
                                        {buildField("latency", `${apiLog?.latency}s`)}
                                    </Grid>
                                </Grid>
                                </Card>
                            </Grid>
                    </Grid>
                </Box>
                <Box py={2} px={2} width="100%">
                    <Grid container alignItems="flex-start" justify="space-between" spacing={3}>
                            <Grid item xs={6}>
                                <Box mb={1}>
                                    <Grid container id="request_body">
                                            <Grid item xs>
                                                {translate("api_logs.detail.request_body") as string}
                                            </Grid>
                                            <Grid item>
                                                <Button
                                                variant="text"
                                                color="primary"
                                                onClick={() => copyToClipoard(apiLog?.request_body)}
                                                startIcon={<FileCopyIcon />}
                                                >
                                                {translate("api_logs.detail.copy") as string}
                                                </Button>
                                            </Grid>
                                        <Grid item xs={12} md={12}>
                                            <CodeInput
                                                value={apiLog?.request_body}
                                                textLabel=""
                                                maxHeight="200px"
                                                height="150px"
                                                isEditable={false}
                                                placeHolder=""
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box mb={1}>
                                    <Grid container id="response">
                                        <Grid item xs>
                                            {translate("api_logs.detail.response") as string}
                                        </Grid>
                                        <Grid item >
                                            <Button
                                            variant="text"
                                            color="primary"
                                            onClick={() => copyToClipoard(apiLog?.response_content)}
                                            startIcon={<FileCopyIcon />}
                                            >
                                            {translate("api_logs.detail.copy") as string}
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <CodeInput
                                                value={apiLog?.response_content}
                                                textLabel=""
                                                maxHeight="200px"
                                                height="150px"
                                                isEditable={false}
                                                placeHolder=""
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>
                </Box>
                <ErrorSnackbar message={error} onClose={onCloseSnackbars} />
                <SuccessSnackbar message={success} onClose={onCloseSnackbars} />
            </Surface>
        </div>
    );

}